import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import { supabase } from '../../lib/supabaseClient';
import './Dashboard.css';

/* ── Icons ─────────────────────────────────────── */
function IconCatalogos() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M3 5v4c0 1.66 4.03 3 9 3s9-1.34 9-3V5" />
      <path d="M3 9v4c0 1.66 4.03 3 9 3s9-1.34 9-3V9" />
      <path d="M3 13v4c0 1.66 4.03 3 9 3s9-1.34 9-3v-4" />
    </svg>
  );
}

function IconBitacoraReq() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
      <rect x="9" y="3" width="6" height="4" rx="1" ry="1" />
      <line x1="9" y1="12" x2="15" y2="12" />
      <line x1="9" y1="16" x2="13" y2="16" />
    </svg>
  );
}

function IconBitacoraAct() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

function IconReportes() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="18" y1="20" x2="18" y2="14" />
      <line x1="12" y1="20" x2="12" y2="12" />
      <line x1="6" y1="20" x2="6" y2="16" />
    </svg>
  );
}

function IconDashboard() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
    </svg>
  );
}

function IconAdministracion() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

/* ── Nav card definitions ──────────────────────── */
const ALL_CARDS = [
  {
    key: 'catalogos',
    label: 'Administrar Catálogos',
    icon: <IconCatalogos />,
    roles: ['Gerente', 'Líder'],
    path: '/catalogs',
  },
  {
    key: 'bitacora-req',
    label: 'Bitácora de Requerimientos',
    icon: <IconBitacoraReq />,
    roles: ['Gerente', 'Líder', 'Desarrollador'],
    path: '/requirements',
  },
  {
    key: 'bitacora-act',
    label: 'Bitácora de Actividades',
    icon: <IconBitacoraAct />,
    roles: ['Gerente', 'Líder', 'Desarrollador'],
    path: '/activities',
  },
  {
    key: 'reportes',
    label: 'Creación de Reportes',
    icon: <IconReportes />,
    roles: ['Gerente', 'Líder'],
    path: '/reports',
  },
  {
    key: 'dashboard-req',
    label: 'Dashboard de Requerimientos',
    icon: <IconDashboard />,
    roles: ['Gerente', 'Líder', 'Desarrollador'],
    path: '/requirements-dashboard',
  },
  {
    key: 'administracion',
    label: 'Administración de Portal',
    icon: <IconAdministracion />,
    roles: ['Gerente'],
    path: '/admin',
  },
];

/* ── Component ─────────────────────────────────── */
function Dashboard() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProfile() {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data } = await supabase
        .from('users')
        .select('full_name, roles(name)')
        .eq('id', user.id)
        .single();
      setProfile(data);
      setLoading(false);
    }
    fetchProfile();
  }, []);

  const firstName = profile?.full_name?.split(' ')[0] ?? '';
  const roleName = profile?.roles?.name ?? '';
  const visibleCards = ALL_CARDS.filter((c) => c.roles.includes(roleName));

  return (
    <div className="dashboard">
      <Navbar />

      <main className="dashboard-main">
        {/* ── Welcome ── */}
        <section className="dashboard-welcome">
          {loading ? (
            <div className="welcome-skeleton">
              <div className="skeleton-line skeleton-line--lg" />
              <div className="skeleton-line skeleton-line--sm" />
            </div>
          ) : (
            <>
              <h1 className="welcome-heading">
                Bienvenid@,{' '}
                <span className="welcome-role">{roleName}</span>{' '}
                <span className="welcome-name">{firstName}</span>
              </h1>
              <p className="welcome-sub">
                Estas son las opciones disponibles para tí
              </p>
            </>
          )}
        </section>

        {/* ── Navigation cards ── */}
        <section className="dashboard-cards">
          {visibleCards.map((card, index) => (
            <button
              key={card.key}
              className="dash-card"
              style={{ '--delay': `${index * 70}ms` }}
              onClick={() => card.path && navigate(card.path)}
            >
              <span className="dash-card-icon">{card.icon}</span>
              <span className="dash-card-label">{card.label}</span>
            </button>
          ))}
        </section>
      </main>

      <footer className="dashboard-footer">
        Created by: Fernando Núñez for WSP International / Ver 1.1.1
      </footer>
    </div>
  );
}

export default Dashboard;
